import { render, staticRenderFns } from "./BmOrderProducts.vue?vue&type=template&id=7fba84e4&"
import script from "./BmOrderProducts.vue?vue&type=script&lang=js&"
export * from "./BmOrderProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports